import { RequestError as r } from "./utils/classes/RequestError.js";
const i = (o) => {
  const e = "https://analytics.locallogic.co/track-v2";
  async function n(a, s) {
    const t = await fetch(`${e}${a}`, {
      body: JSON.stringify(s),
      headers: {
        Accept: "application/json",
        Authorization: o,
        "Content-type": "application/json"
      },
      method: "POST"
    });
    if (!t.ok)
      throw new r(`Could not post tracking event: ${await t.text()}`);
    return t.json();
  }
  return {
    post: n
  };
};
export {
  i as default
};
